/**
 * @generated SignedSource<<fe22e5445b8910a050132bbb1321c950>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProviderProviderIndexGameListPaginationQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  youth?: boolean | null;
  id: string;
};
export type ProviderProviderIndexGameListPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"GameList_provider_games">;
  } | null;
};
export type ProviderProviderIndexGameListPaginationQuery = {
  variables: ProviderProviderIndexGameListPaginationQuery$variables;
  response: ProviderProviderIndexGameListPaginationQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 5,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "youth"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "Variable",
  "name": "youth",
  "variableName": "youth"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "START_TIME"
    }
  },
  {
    "kind": "Literal",
    "name": "times",
    "value": [
      "UPCOMING"
    ]
  },
  (v5/*: any*/)
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProviderProviderIndexGameListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "GameList_provider_games"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProviderProviderIndexGameListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "GameConnection",
                "kind": "LinkedField",
                "name": "games",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Game",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "gameIsFull",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minimumPlayers",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numberOfTeams",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v9/*: any*/),
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "players",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": "players(first:1)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v9/*: any*/),
                                "concreteType": "GameTemplatePositionConnection",
                                "kind": "LinkedField",
                                "name": "positions",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": "positions(first:1)"
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "gameCost",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__id",
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameWiewerTeam",
                            "kind": "LinkedField",
                            "name": "viewerTeam",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerIsAGoaliePlayer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endAge",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startAge",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sport",
                            "kind": "LinkedField",
                            "name": "sport",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "slug",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "goaliesCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerIsAPlayer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Location",
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isOutdoor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "facility",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCancelled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerIsOnWaitingList",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerIsOnRemindMeList",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unlockTimeTz",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "orderBy",
                  "times",
                  "youth"
                ],
                "handle": "connection",
                "key": "GameList_provider_games",
                "kind": "LinkedHandle",
                "name": "games"
              }
            ],
            "type": "Provider",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9444197d7dc413cdfc6e450cb2d368be",
    "id": null,
    "metadata": {},
    "name": "ProviderProviderIndexGameListPaginationQuery",
    "operationKind": "query",
    "text": "query ProviderProviderIndexGameListPaginationQuery(\n  $count: Int = 5\n  $cursor: String\n  $youth: Boolean\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...GameList_provider_games_2hQCqv\n    id\n  }\n}\n\nfragment CalendarIcon_game on Game {\n  startTime\n}\n\nfragment Cost_template on GameTemplate {\n  gameCost\n}\n\nfragment DateTimeTextWaitlist_game on Game {\n  endTime\n  startTime\n}\n\nfragment DateTimeText_game on Game {\n  endTime\n  startTime\n}\n\nfragment GameFeedItem_games_11YXGx on Game {\n  ...GameListItem_game_11YXGx\n  ...GameListItemCompact_game_11YXGx\n  ...GameListItemWaitlist_game\n  ...GameListItemLocked_game\n  id\n  unlockTimeTz\n  gameIsFull\n  startTime\n}\n\nfragment GameFeed_games on Game {\n  ...GameFeedItem_games_11YXGx\n  id\n  startTime\n}\n\nfragment GameListItemCompact_game_11YXGx on Game {\n  ...CalendarIcon_game\n  ...DateTimeText_game\n  ...ProgressBar_game\n  ...ShirtIcon_game\n  ...SportAndAgesText_game\n  ...Title_game\n  url\n  viewerIsAPlayer\n  location {\n    ...LocationText_location\n    id\n  }\n  sport {\n    ...SportIcon_sport\n    slug\n    id\n  }\n  template {\n    ...Cost_template\n    id\n  }\n  isCancelled\n}\n\nfragment GameListItemLocked_game on Game {\n  ...DateTimeTextWaitlist_game\n  ...TitleWaitlist_game\n  ...RemindButton_game\n  ...UpcomingCountdown_game\n  id\n  url\n  location {\n    ...LocationTextWaitlist_location\n    id\n  }\n  sport {\n    slug\n    ...SportIcon_sport\n    id\n  }\n}\n\nfragment GameListItemWaitlist_game on Game {\n  ...DateTimeTextWaitlist_game\n  ...TitleWaitlist_game\n  ...WaitlistButton_game\n  ...ShirtIcon_game\n  viewerIsAPlayer\n  gameIsFull\n  id\n  url\n  location {\n    ...LocationTextWaitlist_location\n    id\n  }\n  numberOfTeams\n  players(first: 1) {\n    pageInfo {\n      total\n    }\n  }\n  sport {\n    slug\n    ...SportIcon_sport\n    id\n  }\n  template {\n    ...Cost_template\n    positions(first: 1) {\n      pageInfo {\n        total\n      }\n    }\n    id\n  }\n}\n\nfragment GameListItem_game_11YXGx on Game {\n  ...CalendarIcon_game\n  ...DateTimeText_game\n  ...ProgressBar_game\n  ...ShirtIcon_game\n  ...SportAndAgesText_game\n  ...Title_game\n  ...GoalieIcon_game\n  url\n  viewerIsAPlayer\n  location {\n    ...LocationText_location\n    id\n  }\n  sport {\n    ...SportIcon_sport\n    slug\n    id\n  }\n  template {\n    ...Cost_template\n    id\n  }\n}\n\nfragment GameList_provider_games_2hQCqv on Provider {\n  games(after: $cursor, first: $count, orderBy: {direction: ASC, field: START_TIME}, times: [UPCOMING], youth: $youth) {\n    edges {\n      node {\n        ...GameFeed_games\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment GoalieIcon_game on Game {\n  goaliesCount\n}\n\nfragment LocationTextWaitlist_location on Location {\n  name\n  facility {\n    name\n    id\n  }\n}\n\nfragment LocationText_location on Location {\n  name\n  isOutdoor\n  facility {\n    name\n    id\n  }\n}\n\nfragment ProgressBar_game on Game {\n  gameIsFull\n  id\n  minimumPlayers\n  numberOfTeams\n  players(first: 1) {\n    pageInfo {\n      total\n    }\n  }\n  template {\n    positions(first: 1) {\n      pageInfo {\n        total\n      }\n    }\n    id\n  }\n}\n\nfragment RemindButton_game on Game {\n  id\n  viewerIsOnRemindMeList\n}\n\nfragment ShirtIcon_game on Game {\n  viewerTeam {\n    color\n  }\n  viewerIsAGoaliePlayer\n}\n\nfragment SportAndAgesText_game on Game {\n  endAge\n  startAge\n  title\n  sport {\n    name\n    id\n  }\n}\n\nfragment SportIcon_sport on Sport {\n  slug\n}\n\nfragment TitleWaitlist_game on Game {\n  title\n  sport {\n    name\n    id\n  }\n}\n\nfragment Title_game on Game {\n  title\n  sport {\n    name\n    id\n  }\n}\n\nfragment UpcomingCountdown_game on Game {\n  unlockTimeTz\n}\n\nfragment WaitlistButton_game on Game {\n  id\n  viewerIsOnWaitingList\n}\n"
  }
};
})();

(node as any).hash = "1d2b4c9582050ef4a2ab2d5cc3b29548";

export default node;
